module.exports = __webpack_public_path__ + "img/com2.30651a66.gif";